import { match } from 'ts-pattern';
import { useWidgetRef } from '~/hooks/widgetHooks';
import CorsoConcierge from './corsoConcierge/CorsoConcierge';
import Kustomer from './kustomer/Kustomer';
import Zendesk from './zendesk/Zendesk';

/**
 * If we are within an integration with a widget `ref`, this will render any side effects.
 * A place to add integrations for other widgets/embeddings.
 * Often for including SDK scripts.
 */
export default function WidgetIntegration() {
  const widgetRef = useWidgetRef();

  return match(widgetRef)
    .with(null, () => null)
    .with('corso-concierge', () => <CorsoConcierge />)
    .with('kustomer', () => <Kustomer />)
    .with('zendesk', () => <Zendesk />)
    .exhaustive();
}
